import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { CreditsPurchasingModal, Button } from '../../components';
import css from './BalancePage.css';
import { usePaymentStatus } from '../../hooks/usePaymentStatus';
import CreditsPurchaseHistory from './CreditsPurchaseHistory';
import { useInitialPackageFromSearchParam } from './useInitialPackageFromSearchParam';
import { SEARCH_PARAM_PACKAGE_KEY, SEARCH_PARAM_PACKAGE_ADD_CREDITS } from './configs';
import { useSelector } from 'react-redux';
import { ErrorBlock } from './ErrorBlock';

export const BalanceTab = () => {
    const history = useHistory();
    const location = useLocation();
    const currentUser = useSelector(s => s.user.currentUser);

    const [modalOpen, setModalOpen] = useState(false);

    const selectedPackage = useInitialPackageFromSearchParam({ setModalOpen });
    const { paymentError, navigateToErrorPage, navigateFromErrorPage } = usePaymentStatus({
        location,
        history,
        pageName: 'BalancePage',
    });

    const {
        privateData: { creditsAvailable = {}, creditsHistory },
        publicData: { userType },
    } = currentUser?.attributes?.profile || { privateData: {}, publicData: {} };

    const creditsForUserType = creditsHistory && creditsHistory[userType];
    const creditsHistoryAvailable =
        !paymentError && Array.isArray(creditsForUserType) && creditsForUserType.length > 0
            ? creditsForUserType
            : null;

    const onClose = () => {
        const queryParams = new URLSearchParams(location.search);
        queryParams.delete(SEARCH_PARAM_PACKAGE_ADD_CREDITS);
        queryParams.delete(SEARCH_PARAM_PACKAGE_KEY);

        setModalOpen(false);

        history.replace({
            search: queryParams.toString(),
        });
    };

    return (
        <section className={css.container}>
            <header className={css.header}>
                <p className={css.subHeading}>Deine Bilanz</p>
            </header>
            <div className={css.boxesHolder}>
                <div className={classNames(css.creditsPurchaseBox, css.box)}>
                    <h2 className={css.creditsPurchaseHeading}>
                        <span>{creditsAvailable[userType] || 0} Credits</span>
                        <p
                            className={css.supportLink}
                            onClick={() => {
                                window.open(
                                    'https://support.horsedeal.com/hc/de/articles/18591062923538',
                                    '_blank'
                                );
                            }}
                        >
                            Was sind Credits?
                        </p>
                    </h2>
                    <Button onClick={() => setModalOpen(true)} className={css.cta}>
                        Credits hinzufügen
                    </Button>
                </div>
            </div>
            {creditsHistoryAvailable ? (
                <CreditsPurchaseHistory
                    creditsHistoryAvailable={[...creditsHistoryAvailable]
                        .filter(creditItem => !creditItem?.rewardAvailableAt)
                        .sort(
                            (a, b) =>
                                new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
                        )}
                />
            ) : (
                <ErrorBlock
                    paymentError={paymentError}
                    navigateFromErrorPage={navigateFromErrorPage}
                />
            )}

            {modalOpen && (
                <CreditsPurchasingModal
                    isOpen
                    currentUser={currentUser}
                    initialPackage={selectedPackage}
                    onClose={onClose}
                    onError={() => {
                        setModalOpen(false);
                        navigateToErrorPage();
                    }}
                />
            )}
        </section>
    );
};
